export default __webpack_public_path__ + "static/media/Bandeau 17.80712e96.jpg";